<template>
  <div class="product-wrapper">
    <div class="product-header">
      <div class="product-header-img-container">
        <img
          src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/product-header-0.png"
          alt=""
        />
        <img
          src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/product-header-1.png"
          alt=""
        />
        <img
          src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/product-header-2.png"
          alt=""
        />
        <img
          src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/product-header-3.png"
          alt=""
        />
        <img
          src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/product-header-4.png"
          alt=""
        />
        <img
          src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/product-header-5.png"
          alt=""
        />
        <img
          src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/product-header-6.png"
          alt=""
        />
        <img
          src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/product-header-7.png"
          alt=""
        />
        <img
          src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/product-header-8.png"
          alt=""
        />
      </div>
      <div class="product-intro">
        <div class="intro-title">{{ isChinese ? '产品介绍' : 'Product Introduction'}}</div>
        <div class="intro-content">
          {{  isChinese ?  `“渔遥渔鹰”是公司利用AI和卫星技术开发的渔业信息服务平台，立体监测海洋环境、精准定位鱼群，开启海洋捕鱼AI新时代。` : `"FishAwk" is a fishery information service platform developed by the company using AI and satellite technology, which can monitor the marine environment in three dimensions, accurately locate fish schools, and usher in a new era of AI in marine fishing.`  }}
        </div>
      </div>
    </div>
    <div class="product-feature">
      <div class="feature-title">{{ isChinese ? '产品特色' : 'Product Features'}}</div>
      <div class="feature-img-container">
        <img class="feature1" src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/feature1.png" alt="" />
        <img class="feature2" src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/feature2.png" alt="" />
        <img class="feature3" src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/feature3.png" alt="" />
      </div>
    </div>
    <div class="ai-data">
      <div class="ai">
        <div class="ai-title">{{ isChinese ? 'AI预报渔场' : 'AI Prediction Of Fishing Grounds'}}</div>
        <img src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/ai.png" alt="" />
      </div>
      <div class="data">
        <div class="data-title">{{ isChinese ? '实时海况数据' : 'Real Time Sea State Data'}}</div>
        <img src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/data.png" alt="" />
      </div>
    </div>
    <div class="market">
      <div class="market-left">
        <span class="market-title">{{ isChinese ? '国际市场' : 'International Market'}}</span>
        <span class="market-content"
          >{{ isChinese ? '目前，已有600多艘渔船使用“渔遥渔鹰”，遍布我国的东海、南海和黄渤海，以及印度洋、大西洋和太平洋等海域。' : `At present, more than 600 fishing boats are using the "FishAwk", covering the East China Sea, South China Sea, Yellow Sea and Bohai Sea, as well as the Indian Ocean, Atlantic Ocean and Pacific Ocean in China.` }}</span
        >
      </div>
      <div class="market-right">
        <img src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/market.png" alt="" />
      </div>
    </div>
    <div class="catch">
      <div class="catch-title">{{ isChinese ? '渔获满满' : 'Catchful catch'}}</div>
      <div class="catch-img-container">
        <img src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/market1.png" alt="" />
        <img src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/market2.png" alt="" />
        <img src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/market3.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapState(["isChinese"]),
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.product-wrapper {
  padding-bottom: 200px;
}
.product-header {
  // 父容器设为相对定位，作为绝对定位子元素的基准
  position: relative;
  .product-header-img-container {
    display: flex;
    flex-wrap: wrap;
    img {
      width: calc(100% / 3);
    }
  }

  .product-intro {
    // 绝对定位悬浮于图片之上
    //calc((100% - var(--breakpoint-x)) / 2)
    position: absolute;
    top: 20%;
    left: 10%;
    z-index: 2;
    color: white;

    // 视觉样式增强（参考悬浮设计案例）
    padding: 20px;
    max-width: 400px; // 限制宽度防止溢出

    .intro-title {
      font-size: var(--titleFontSize);
      font-weight: bold;
      font-style: italic;
      margin-bottom: 50px;
    }

    .intro-content {
      font-size: var(--contentFontSize);
    }
  }
}

.product-feature {
  margin-top: 200px;
  width: 100%;
  box-sizing: border-box;
  padding: 0 calc((100% - var(--breakpoint-x)) / 2);
  min-width: var(--breakpoint-z);
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  .feature-title {
    font-size: var(--titleFontSize);
    font-weight: bold;
    font-style: italic;
    margin-bottom: 50px;
    color: rgb(4, 109, 209);
  }
  .feature-img-container {
    display: flex;
    justify-content: space-around;
    gap: 40px;

    img {
      height: 340px;
    }
  }
  .feature-body {
    display: flex;
    flex-direction: row;
    gap: 40px;
    .feature-container {
      display: flex;
      flex-direction: column;
      border: 1px solid rgb(10, 113, 210);
      img {
        width: 100%;
        display: block;
      }
      .feature-intro {
        padding: 20px 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: var(--contentFontSize);
        color: rgb(10, 113, 210);
      }
    }
  }
}
.ai-data {
  width: 100%;
  box-sizing: border-box;
  padding: 0 calc((100% - var(--breakpoint-x)) / 2);
  min-width: var(--breakpoint-z);
  margin-top: 200px;
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  .ai,
  .data {
    width: 50%;
    display: flex;
    flex-direction: column;
    .ai-title,
    .data-title {
      font-size: var(--titleFontSize);
      font-weight: bold;
      font-style: italic;
      margin-bottom: 50px;
      color: rgb(4, 109, 209);
    }
    img {
      width: 90%;
    }
  }
  .data {
    margin-top: 300px;
    align-items: flex-end;
  }
}
.market {
  width: 100%;
  box-sizing: border-box;
  padding: 0 calc((100% - var(--breakpoint-x)) / 2);
  min-width: var(--breakpoint-z);
  display: flex;
  justify-content: space-between;
  gap: 150px;
  margin-top: 200px;
  flex-wrap: nowrap;
  .market-left {
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    flex-shrink: 0;
    flex: 1 1 40%; // 允许伸缩，基础宽度50%
    min-width: 0; 
    // width: 400px;
    .market-title {
      font-size: var(--titleFontSize);
      font-weight: bold;
      font-style: italic;
      margin-bottom: 50px;
      color: rgb(4, 109, 209);
    }
    .market-content {
      font-size: var(--contentFontSize);
      color: rgb(10, 113, 210);
    }
  }
  .market-right {
    box-sizing: border-box;
    flex: 1 1 60%; // 允许伸缩，基础宽度50%
    min-width: 0;
    img {
      width: 100%;
    }
  }
}
.catch {
  width: 100%;
  box-sizing: border-box;
  padding: 0 calc((100% - var(--breakpoint-x)) / 2);
  min-width: var(--breakpoint-z);
  display: flex;
  flex-direction: column;
  margin-top: 200px;
  flex-wrap: nowrap;
  .catch-title {
    font-size: var(--titleFontSize);
    font-weight: bold;
    font-style: italic;
    margin-bottom: 50px;
    color: rgb(4, 109, 209);
  }
  .catch-img-container {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 40px;
    img {
      width: calc((100% - 80px) / 3);
    }
  }
}

@media (max-width: 1300px) {
  .catch,.product-feature, .ai-data, .market {
    padding: 0 50px;
    margin-top: 100px;
  }
  .intro-title,.feature-title,.ai-title,.data-title,.market-title,.catch-title {
    font-size: var(--smallTitleFontSize)!important;
  }
  .intro-content,.feature-intro,.market-content {
    font-size: var(--smallContentFontSize)!important;
  }
  .feature-img-container {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    img {
      height: 240px !important;
    }
  }
  .product-intro {
    top: 15%!important;
    // 视觉样式增强（参考悬浮设计案例）
    padding: 15px!important;
    max-width: 300px!important; // 限制宽度防止溢出
    .intro-title {
      margin-bottom: 30px!important;
    }
  }
}
@media (max-width: 768px) {
  .catch,.product-feature, .ai-data, .market {
    flex-wrap: wrap;
  }
  .market  {
    gap: 50px;
  }

  .intro-title,.feature-title,.ai-title,.data-title,.market-title,.catch-title {
    font-size: var(--miniContentFontSize) !important;
  }
  .intro-content,.feature-intro,.market-content {
    font-size: var(--miniContentFontSize) !important;
  }
  .catch-img-container {
    gap: 0px;
    img {
      width: 100% !important;
    }
  }
  .product-intro {
    top: 0px!important;
    // 视觉样式增强（参考悬浮设计案例）
    padding: 10px!important;
    max-width: 250px!important; // 限制宽度防止溢出
    .intro-title {
      margin-bottom: 15px!important;
    }
  }
}
</style>